<script setup>
import {ref, onMounted, defineEmits} from 'vue';

const searchText = ref('');
const filteredCountries = ref([]);
const selectedCountry = ref(null);
const emits = defineEmits(['update:country']);

let allCountries = [];

onMounted(async () => {
  try {
    const response = await fetch('https://restcountries.com/v3.1/all');
    const data = await response.json();
    allCountries = data.map((country) => ({
      alpha2Code: country.cca2,
      // If english country name preferred: country.name.common
      name: country.demonyms?.fra?.f || country.translations.fra.common,
      flag: country.flags.svg,
    }));
    selectCountry(allCountries.find(c => c.alpha2Code === "FR")) // Default
    filteredCountries.value = allCountries;
  } catch (error) {
    console.error('Failed to fetch countries data:', error);
  }
});

const filterCountries = () => {
  const query = searchText.value.toLowerCase();
  // Normalize and convert the query to lowercase
  const normalizedQuery = query.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  filteredCountries.value = allCountries.filter((country) => {
    // Normalize and convert the country name to lowercase
    const normalizedCountryName = country.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    // Check if the normalized country name contains the normalized query
    return normalizedCountryName.toLowerCase().includes(normalizedQuery);
  });
};

const selectCountry = (country) => {
  searchText.value = country.name; // Set the search text to the selected country's name
  selectedCountry.value = country;
  emits('update:country', country.alpha2Code)
};
</script>
<template>
  <div>
    <input
        v-if="!selectedCountry"
        v-model="searchText"
        @input="filterCountries"
        type="text"
        placeholder="Rechercher un pays"
        class="block w-full rounded-md border-0 bg-white py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6 items-center	cursor-pointer"
    />
    <div
        @click="selectedCountry = null"
        v-else
        class="flex block w-full bg-white pl-3 py-1\.5 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6 items-center	cursor-pointer"
    >
      <img :src="selectedCountry.flag" alt="Flag" class="inline-block w-6 h-4 mr-2 rounded-sm"/>
      {{ selectedCountry.name }}
    </div>

    <div v-if="!selectedCountry && searchText !== '' && filteredCountries.length > 0"
         class="absolute w-full mt-2 overflow-y-scroll bg-white border rounded-md shadow-sm max-h-32">
      <div
          v-for="country in filteredCountries"
          :key="country.alpha2Code"
          @click="selectCountry(country)"
          class="flex items-center p-2 cursor-pointer hover:bg-gray-100"
      >
        <img :src="country.flag" alt="Flag" class="inline-block w-6 h-4 mr-2 rounded-sm"/>
        {{ country.name }}
      </div>
    </div>
  </div>
</template>
